import DictionaryItem from "../../../../../model/dictionary/DictionaryItem";
import SelectComponent, {SelectComponentComponentProps, SelectComponentReduxProps} from "../../../../ui/select/SelectComponent";
import {RootState} from "../../../../../store/reducer/root/RootState";
import {connect} from "react-redux";


class SelectMerchant extends SelectComponent<DictionaryItem> {
	matchFilter(element: DictionaryItem, filter: string): boolean {
		return element.name.toLowerCase().indexOf(filter.toLowerCase()) > -1;
	}

	elementToId(element: DictionaryItem): string {
		return element.id;
	}

	elementToString(element: DictionaryItem) {
		return element.name;
	}
}

function mapStateToProps(state: RootState) {
	return {
		items: state.merchant.merchants
	}
}

export default connect<SelectComponentReduxProps<DictionaryItem>, SelectComponentComponentProps<DictionaryItem>>(mapStateToProps)(
	SelectMerchant)